export const blockIconsNavigationArrowBackiOS = (
	<span className='material-symbols-outlined'>arrow_back_ios</span>
);
